import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
//import { Link } from "react-router-dom";
import { IconDownload, IconLike, ArrowRight, Vote, Voted } from '../assets/images/icons/icons';
import { GetRecipeIDByCombinationID } from '../data/platform/get_workato_recipe_by_combinationid';
import { GetWorkatoRecipeByID } from '../data/workato/get-recipe';
import { Console, envInstanceName } from '../services/platform-api';
import moment from 'moment';
import { useAxios } from '../hooks/useAxios';
import { useDecision } from '@optimizely/react-sdk';
import WFSettings from '../data/platform/workflow_settings.json';
import { ArchieImg } from '../assets/images/images';

const CardCombination = ({
  uniq_key,
  combinationData,
  onlyactive = false,
  recommended = false,
  activeCombos,
  setActiveCombos,
  totalCount,
  setLoadingDone,
}) => {
  const [recon_wf_toggle] = useDecision('wf_visiable_by_id');

  const { fetchNow } = useAxios();
  const [voted, setVoted] = useState(false);
  const [votes, setVotes] = useState(0);

  Console('combinations - are we getting onlyactive ? ', onlyactive, 'log');

  let recipe;
  let icon = '/images/' + combinationData.icon;
  let title = combinationData.name;
  let subtitle = combinationData.sub_title;
  let date = moment(combinationData.created_time).format('LL');
  //  let time = moment(combinationData.created_time).format('LT');
  let id = combinationData.id;
  let connectors = combinationData.connectors;
  let status = combinationData.status;
  let my_vote = combinationData.my_vote;
  //  let workato_recipe = null;
  let workato_recipe_id = combinationData.recipe_id;

  let basic = title.includes('basic');
  title = title.replace('(basic)', '');
  Console('title ###', title, 'log');
  Console('combinationData.connectors', combinationData.connectors, 'log');

  // get our workato recipe combo data from platform
  //  workato_recipe = GetRecipeIDByCombinationID(id);
  Console('combinationData.id ', combinationData.id);
  Console('recon_wf_toggle ', recon_wf_toggle);
  //  Console('workato_recipe ##########', workato_recipe, 'log');

  Console('workato_recipe_id ', workato_recipe_id, 'log');
  recipe = GetWorkatoRecipeByID(workato_recipe_id);
  Console('recipe recipe ', recipe, 'log');

  // optimizely lockdown check
  if (recon_wf_toggle?.enabled === false) {
    let temp_env = '';
    if (envInstanceName === '') {
      temp_env = 'prod';
    } else {
      temp_env = envInstanceName;
    }
    Console('envInstanceName ', temp_env, 'log');
    if (
      recon_wf_toggle.variables?.combination_ids &&
      recon_wf_toggle.variables?.combination_ids[temp_env].includes(combinationData.id)
    ) {
      status = 'coming_soon';
    }
  }

  useEffect(() => {
    setVotes(combinationData.votes);

    if (onlyactive) {
      if (combinationData.authed) {
        if (recipe?.job_failed_count > 0 || recipe?.job_succeeded_count > 0) {
          setActiveCombos((activeCombos) => {
            // Check if combinationData.id already exists in the array
            if (!activeCombos.includes(combinationData.id)) {
              // If it does not exist, add it to the array
              return [...activeCombos, combinationData.id];
            }
            // If it already exists, return the current array without modifying it
            return activeCombos;
          });
        }
      }
    }

    if (uniq_key + 1 === totalCount && recipe && (recommended || onlyactive)) {
      setLoadingDone(false);
    }
  }, [combinationData.votes, onlyactive, recipe?.running, activeCombos, uniq_key]);

  const handleVote = (e) => {
    e.preventDefault();
    const new_votes = votes + 1;
    setVotes(new_votes);

    const payload = {
      combination_id: id,
    };
    fetchNow(`/api/platform/votes`, 'Post', payload, false);
    setVoted(true);
  };

  const TheCombo = () => {
    return (
      <a
        href={
          status === 'coming_soon'
            ? // optimizly wf toggle
              '#'
            : basic
            ? `/solutions/combinations/basic-workflow/${id}`
            : `/solutions/combinations/workflow/${id}`
        }
        {...(status === 'coming_soon'
          ? my_vote || voted
            ? { disabled: true }
            : { onClick: (e) => handleVote(e) }
          : {})}
        data-testid={`${id}`}
        key={uniq_key}
        className={`${recipe?.running ? 'card card-combinations connected px-4' : 'card card-combinations px-4'} ${
          status === 'coming_soon' ? (my_vote || voted ? 'coming-soon disabled' : 'coming-soon') : ''
        }`}
        rel="noopener"
      >
        <div className="card-header">
          <Row>
            <Col lg={1} sm={1}>
              <img src={icon} alt="" />
            </Col>
            <Col lg={7} sm={8}>
              {title}
              <br />
              <strong>{subtitle}</strong>
            </Col>
            <Col lg={4} sm={3} className="right">
              {status === 'coming_soon' ? ( // optimizly wf toggle
                <div className="badge-status comingsoon">Coming Soon</div>
              ) : combinationData.authed && (recipe?.job_failed_count > 0 || recipe?.job_succeeded_count > 0) ? (
                <div className="badge-status connected">Connected</div>
              ) : (
                <div className="badge-status inactive">Inactive</div>
              )}

              {WFSettings.solution_comboIDs.finance.includes(id) ? (
                <img src={ArchieImg} className="ai_assistant" alt="Archie" />
              ) : null}
            </Col>
          </Row>
        </div>
        <div className="card-body">
          <Row>
            <Col lg={12}>
              <hr />
            </Col>

            <Col lg={12}>
              <h4 className="mb-4">{date}</h4>
            </Col>

            <Col lg={12}>
              <div className="mb-4">
                {connectors.length > 0
                  ? connectors
                      .sort((a, b) => (a.order > b.order ? 1 : -1))
                      .map((connectorsData) => {
                        return (
                          <img
                            src={`/images/${connectorsData.icon}`}
                            alt={connectorsData.name}
                            className="icon-solutions"
                            key={connectorsData.id}
                          />
                        );
                      })
                  : 'To DO...Probably no recipe attached.'}
              </div>
            </Col>
          </Row>
          <Row>
            {connectors && status !== 'coming_soon' ? (
              <Col lg={6} sm={6}>
                <h4>Downloads</h4>
                <p>
                  <img src={IconDownload} alt="Downloads" /> 0
                </p>
              </Col>
            ) : null}
            {my_vote || voted || (connectors && status !== 'coming_soon') ? (
              <Col lg={6} sm={6}>
                <h4>Likes</h4>
                <p>
                  <img src={IconLike} alt="IconLike" /> {votes ? votes : null}
                </p>
              </Col>
            ) : null}
          </Row>
        </div>
        <div className="card-footer">
          {status === 'coming_soon' ? ( // optimizly wf toggle
            <>
              {my_vote || voted ? (
                <>
                  Thanks for your vote &nbsp;
                  <img src={Voted} alt="Voted" />
                </>
              ) : (
                <span>
                  Vote to get this combination sooner &nbsp;
                  <img src={Vote} alt="Vote" className="btn-vote" />
                </span>
              )}
            </>
          ) : basic ? (
            <span className="btn btn-primary">
              {recipe?.running ? 'Use Now' : 'Get Now'} &nbsp;
              <img src={ArrowRight} alt="Go" height="12px" />
            </span>
          ) : (
            <span className="btn btn-primary">
              {recipe?.running ? 'Use Now' : 'Get Now'} &nbsp;
              <img src={ArrowRight} alt="Go" height="12px" />
            </span>
          )}
        </div>
      </a>
    );
  };

  // if (onlyactive && recipe?.running) {
  if (onlyactive) {
    if (combinationData.authed) {
      Console('only active authed ?. ', combinationData.authed, 'log');
      if (recipe?.job_failed_count > 0 || recipe?.job_succeeded_count > 0) {
        Console('YES..... ', recipe, 'log');
        return (
          <Col xxlg={6} xl={6} lg={6} md={12}>
            <TheCombo />
          </Col>
        );
      }
    }
  } else if (recommended) {
    if (recipe?.job_failed_count === 0 && recipe?.job_succeeded_count === 0) {
      Console('YES..... ', recommended, 'log');
      // if (!recipe?.running) {
      return (
        <Col xxlg={6} xl={6} lg={6} md={12}>
          <TheCombo />
        </Col>
      );
    }
  } else if (onlyactive && !recipe?.running) {
    Console('not running exclude ', recipe?.running, 'log');
    // return null;
  } else {
    return TheCombo();
  }
};

export { CardCombination };
